"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AAGUID_TO_LABEL = exports.userRoles = exports.unauthenticatedUser = exports.unauthenticatedConfig = exports.typesOfPreaching = exports.sseEvents = exports.notificationTypes = exports.notificationSettingTypes = exports.newUsherAssignments = exports.newAvAssignments = exports.newAttendance = exports.httpHeaders = exports.emptyHthFace = exports.cartPriorities = exports.boardItemTypes = exports.millisecondsSixMonths = exports.millisecondsNinetyDays = exports.millisecondsFortyDays = exports.millisecondsThirtyDays = exports.millisecondsSevenDays = exports.millisecondsOneDay = exports.millisecondsThreeHours = exports.millisecondsOneHour = exports.millisecondsTwentyFiveMinutes = exports.millisecondsFiveMinutes = exports.millisecondsTwoMinutes = exports.millisecondsOneMinute = exports.phoneE164Pattern = exports.emailPattern = exports.urlEncodingPlus = exports.urlEncodingPercentage = exports.urlEncodingLineBreak = exports.telephonicNotPreachedText = exports.monthsShort = exports.months = exports.initialPhoneNumber = exports.emailForDeletedUsers = exports.daysOfWeekMobileD = exports.daysOfWeekMobile = exports.daysOfTheWeekS = exports.daysOfTheWeekP = exports.daysOfTheWeekAsNumbers = exports.assignmentU2 = exports.assignmentU1 = exports.assignmentA5 = exports.assignmentA4 = exports.assignmentA3 = exports.assignmentA2 = exports.assignmentA1 = void 0;
exports.assignmentA1 = 'Consola';
exports.assignmentA2 = 'Zoom';
exports.assignmentA3 = 'Micrófono 1';
exports.assignmentA4 = 'Micrófono 2';
exports.assignmentA5 = 'Plataforma';
exports.assignmentU1 = 'Acomodador Entrada';
exports.assignmentU2 = 'Acomodador Auditorio';
exports.daysOfTheWeekAsNumbers = [1, 2, 3, 4, 5, 6, 0];
exports.daysOfTheWeekP = ['Domingos', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábados'];
exports.daysOfTheWeekS = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
exports.daysOfWeekMobile = ['L', 'M', 'Mi', 'J', 'V', 'S'];
exports.daysOfWeekMobileD = ['D', 'L', 'M', 'Mi', 'J', 'V', 'S'];
exports.emailForDeletedUsers = 'eliminado';
exports.initialPhoneNumber = '+54911';
exports.months = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
exports.monthsShort = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];
exports.telephonicNotPreachedText = 'No predicado';
exports.urlEncodingLineBreak = '%0A';
exports.urlEncodingPercentage = '%25';
exports.urlEncodingPlus = '%2B';
//
exports.emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
exports.phoneE164Pattern = /^\+[1-9]\d{6,14}$/;
//
exports.millisecondsOneMinute = 60 * 1000;
exports.millisecondsTwoMinutes = 2 * exports.millisecondsOneMinute;
exports.millisecondsFiveMinutes = 5 * exports.millisecondsOneMinute;
exports.millisecondsTwentyFiveMinutes = 25 * exports.millisecondsOneMinute;
exports.millisecondsOneHour = 60 * exports.millisecondsOneMinute;
exports.millisecondsThreeHours = 3 * exports.millisecondsOneHour;
exports.millisecondsOneDay = 24 * exports.millisecondsOneHour;
exports.millisecondsSevenDays = 7 * exports.millisecondsOneDay;
exports.millisecondsThirtyDays = 30 * exports.millisecondsOneDay;
exports.millisecondsFortyDays = 40 * exports.millisecondsOneDay;
exports.millisecondsNinetyDays = 90 * exports.millisecondsOneDay;
exports.millisecondsSixMonths = 180 * exports.millisecondsOneDay;
//
exports.boardItemTypes = [{
  type: 'avUshers',
  label: 'Asignaciones de Audio y Video y Acomodadores'
}, {
  type: 'carts',
  label: 'Asignaciones Carritos'
}, {
  type: 'cleaning',
  label: 'Limpieza del Salón'
}, {
  type: 'file',
  label: 'Archivo PDF'
}, {
  type: 'groups',
  label: 'Grupos de Predicación'
}, {
  type: 'midweekMeetings',
  label: 'Asignaciones Reuniones de Entresemana'
}, {
  type: 'publicMeetings',
  label: 'Asignaciones Reuniones Públicas'
}, {
  type: 'publicMinistry',
  label: 'Salidas de Predicación'
}, {
  type: 'text',
  label: 'Texto'
}];
exports.cartPriorities = [{
  label: 'Alta',
  value: 1
}, {
  label: 'Media',
  value: 2
}, {
  label: 'Baja',
  value: 3
}];
exports.emptyHthFace = {
  block: '1',
  buildings: [],
  coordsPoint1: {
    lat: 0,
    lng: 0
  },
  coordsPoint2: {
    lat: 0,
    lng: 0
  },
  coordsPoint3: {
    lat: 0,
    lng: 0
  },
  dateOfLastSharing: null,
  doNotCalls: [],
  face: 'A',
  id: 0,
  observations: [],
  serviceDates: [],
  street: '',
  territoryNumber: '1'
};
exports.httpHeaders = {
  accept: 'Accept',
  authToken: 'x-auth-token',
  contentDisposition: 'Content-Disposition',
  contentType: 'Content-Type',
  contentTypeApplicationJson: 'application/json',
  contentTypeAuthorizationOpenCors: 'Authorization',
  contentTypeMultipartFormData: 'multipart/form-data',
  recaptchaToken: 'x-recaptcha-token',
  requestDomain: 'x-request-domain',
  schedulerToken: 'x-scheduler-token',
  twilioToken: 'x-twilio-signature'
};
exports.newAttendance = {
  inPerson: 0,
  notes: '',
  youtube: 0,
  zoom: 0
};
exports.newAvAssignments = [{
  name: exports.assignmentA1,
  user: null
}, {
  name: exports.assignmentA2,
  user: null
}, {
  name: exports.assignmentA3,
  user: null
}, {
  name: exports.assignmentA4,
  user: null
}, {
  name: exports.assignmentA5,
  user: null
}];
exports.newUsherAssignments = [{
  name: exports.assignmentU1,
  user: null
}, {
  name: exports.assignmentU2,
  user: null
}];
exports.notificationSettingTypes = [{
  label: 'Tal día de la misma semana',
  shortLabel: 'la misma semana',
  type: 1
}, {
  label: 'Tal día de la semana anterior',
  shortLabel: 'la semana anterior',
  type: 2
}, {
  label: 'Tal día, dos semanas antes',
  shortLabel: 'dos semanas previas',
  type: 3
}, {
  label: 'Tal día, tres semanas antes',
  shortLabel: 'tres semanas previas',
  type: 4
}, {
  label: 'El mismo día',
  shortLabel: '',
  type: 5
}, {
  label: 'El día anterior',
  shortLabel: '',
  type: 6
}, {
  label: 'Dos días antes',
  shortLabel: '',
  type: 7
}, {
  label: 'Siete días antes',
  shortLabel: '',
  type: 8
}];
exports.notificationTypes = [{
  key: 'carts',
  label: 'Carritos',
  type: 'carts',
  isFirstPage: true
},
//
{
  key: 'publicMinistry',
  label: 'Servicio del Campo',
  type: 'public-ministry',
  isFirstPage: true
},
//
{
  key: 'midweek',
  label: 'Vida y Ministerio',
  type: 'meetings-midweek-assignment',
  isFirstPage: true,
  isMidweekMeeting: true
}, {
  key: 'midweekAVUshers',
  label: 'Vida y Ministerio: AV. y Acomodadores',
  type: 'meetings-midweek-av-ushers',
  isMidweekMeeting: true
}, {
  key: 'midweekCleaning',
  label: 'Vida y Ministerio: Limpieza por Grupos',
  type: 'meetings-midweek-cleaning',
  isMidweekMeeting: true
},
//
{
  key: 'public',
  label: 'Reunión Pública',
  type: 'meetings-public-assignment',
  isFirstPage: true,
  isPublicMeeting: true
}, {
  key: 'publicAVUshers',
  label: 'Reunión Pública: AV. y Acomodadores',
  type: 'meetings-public-av-ushers',
  isPublicMeeting: true
}, {
  key: 'publicCleaning',
  label: 'Reunión Pública: Limpieza por Grupos',
  type: 'meetings-public-cleaning',
  isPublicMeeting: true
}];
exports.sseEvents = {
  hthChange: 'hth: change',
  telephonicChange: 'telephonic: change',
  userChange: 'user: change'
};
exports.typesOfPreaching = [{
  label: 'Exhibidores/Carritos',
  type: 'cart'
}, {
  label: 'Casa en Casa',
  type: 'house-to-house'
}, {
  label: 'Vía Pública',
  type: 'public-way'
}, {
  label: 'Telefónica',
  type: 'telephonic'
}];
exports.unauthenticatedConfig = {
  centralPointCoordinates: null,
  congregation: 0,
  congregationArea: null,
  date: 0,
  invitations: [],
  isDisabledEditHthMaps: true,
  isDisabledHthFaceObservations: true,
  isEnabledAvUshersPublicPage: false,
  isEnabledCartsPublicPage: false,
  isEnabledCleaningPublicPage: false,
  isEnabledHthDoubleState: false,
  isSharingHthAll: false,
  isUsingLettersForBlocks: false,
  name: '',
  numberOfGroups: 0,
  numberOfTerritories: 0
};
exports.unauthenticatedUser = {
  cartAssignments: [],
  congregation: 0,
  email: '',
  group: null,
  groupIsTheAssistance: false,
  groupIsTheOverseer: false,
  hthAssignments: [],
  id: 0,
  isActive: false,
  isAdmin: false,
  isAuth: false,
  isBoardAdmin: false,
  isBuildingsAdmin: false,
  isCartsAdmin: false,
  isHthAdmin: false,
  isSuperAdmin: false,
  isTelephonicAdmin: false,
  meetingsWithAssignments: [],
  otpOptions: [],
  phoneAssignments: [],
  publicMinistryAssignments: [],
  recoveryOptions: [],
  roles: [],
  rolesAsText: '',
  webAuthnAuthenticators: []
};
exports.userRoles = [{
  description: 'Puede realizar todas las funciones de los otros administradores pero también manipula los usuarios, los grupos y las notificaciones y puede leer todos los logs del sistema y editar la configuración general de la aplicación para la congregación.',
  name: 'Administradores Generales',
  number: 1
}, {
  description: 'Accede y maneja los territorios de Casa en Casa, edita mapas, manipula edificios, no tocar, observaciones, asignaciones, comparte, consulta sus logs. No tiene límites en la pantalla de Casa en Casa ni en la sección de Casa en Casa para Administradores.',
  name: 'Administradores de Casa en Casa',
  number: 2
}, {
  description: 'Accede y maneja todos los territorios de Telefónica sin necesidad de asignación, asigna, resetea, consulta sus logs. No tiene límites en las páginas de Telefónica ni en la sección de Telefónica para Administradores.',
  name: 'Administradores de Telefónica',
  number: 3
}, {
  description: 'Controla completamente los Carritos/Exhibidores y consulta sus logs.',
  name: 'Administradores de Carritos',
  number: 4
}, {
  description: 'Accede a todos los territorios de Casa en Casa y puede crear, editar y eliminar edificios. No consulta sus logs.',
  name: 'Administradores de Edificios de Casa en Casa',
  number: 5
}, {
  description: 'Controla completamente el Tablero y consulta sus logs.',
  name: 'Administradores del Tablero',
  number: 6
}, {
  description: 'Tiene control total de las páginas de las Reuniones, Audio, Video y Acomodadores y la asistencia, consulta sus logs',
  // cambiar
  name: 'Administradores de las Reuniones',
  number: 7
}];
//
exports.AAGUID_TO_LABEL = {
  '01020304-0506-0708-0102-030405060708': 'Virtual Authenticator',
  '08987058-cadc-4b81-b6e1-30de50dcbe96': 'Windows Hello',
  '0ea242b4-43c4-4a1b-8b17-dd6d0b6baec6': 'Keeper',
  '17290f1e-c212-34d0-1423-365d729f09d9': 'Thales PIN iOS SDK',
  '39a5647e-1853-446c-a1f6-a79bae9f5bc7': 'IDmelon',
  '50726f74-6f6e-5061-7373-50726f746f6e': 'Proton Pass',
  '531126d6-e717-415c-9320-3d9aa6981239': 'Dashlane',
  '53414d53-554e-4700-0000-000000000000': 'Samsung Pass',
  '6028b017-b1d4-4c02-b4b3-afcdafc96bb2': 'Windows Hello',
  '66a0ccb3-bd6a-191f-ee06-e375c50b9846': 'Thales Bio iOS SDK',
  '771b48fd-d3d4-4f74-9232-fc157ab0507a': 'Edge on Mac',
  '8836336a-f590-0921-301d-46427531eee6': 'Thales Bio Android SDK',
  '9ddd1817-af5a-4672-a2b9-3e3dd95000a9': 'Windows Hello',
  'adce0002-35bc-c60a-648b-0b25f1f05503': 'Chrome on Mac',
  'b5397666-4885-aa6b-cebf-e52262a439a2': 'Chromium Browser',
  'b84e4048-15dc-4dd0-8640-f4f60813c8af': 'NordPass',
  'bada5566-a7aa-401f-bd96-45619a55120d': '1Password',
  'cd69adb5-3c7a-deb9-3177-6800ea6cb72a': 'Thales PIN Android SDK',
  'd548826e-79b4-db40-a3d8-11116f7e8349': 'Bitwarden',
  'dd4ec289-e01d-41c9-bb89-70fa845d4bf2': 'iCloud Keychain (Managed)',
  'ea9b8d66-4d01-1d21-3ce4-b6b48cb575d4': 'Google Password Manager',
  'f3809540-7f14-49c1-a8b3-8f813b225541': 'Enpass',
  'fbfc3007-154e-4ecc-8c0b-6e020557d7bd': 'iCloud Keychain',
  'fdb141b2-5d84-443e-8a35-4698c205a502': 'KeePassXC'
};